export default __webpack_public_path__ + "static/media/win.ee26c1d5.png";